import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AddAdvertiserModal from './AddAdvertiserModal';
import { StyledButton } from '../../../Components/Generics.styled';

const ViewAdvertisersContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.div`
    margin-top: 80px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const StyledTableContainer = styled.div`
    margin-top: 40px;
`;

const ViewAdvertisers = (props) => {
    const {
        agencyAdvertiserData,
        createNewAdvertiser,
        newAdvertiser,
        setNewAdvertiser,
        postData,
        modalIsOpen,
        setModalIsOpen,
        resetFields,
        currentAdvertiser,
    } = props;

    const agencysAdvertisers = agencyAdvertiserData;

    const role = {
        isAgencyManager: currentAdvertiser?.isAgencyManager,
    };

    const [tableRows, setTableRows] = useState([]);

    const createData = (
        companyName,
        companyWebsite,
        firstName,
        lastName,
        email,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        city,
        province,
        zipCode
    ) => {
        return {
            companyName,
            companyWebsite,
            firstName,
            lastName,
            email,
            title,
            primaryPhone,
            mobilePhone,
            streetAddress,
            city,
            province,
            zipCode,
        };
    };

    const addDataToRows = () => {
        let sortedAdvertisers = [];
        if (agencysAdvertisers && agencysAdvertisers.length > 0) {
            sortedAdvertisers = [...agencysAdvertisers].sort((a, b) => {
                const companyNameA = a.companyName.toLowerCase();
                const companyNameB = b.companyName.toLowerCase();
                if (companyNameA < companyNameB) {
                    return -1;
                }
                if (companyNameA > companyNameB) {
                    return 1;
                }
                return 0;
            });
        }

        const rows = sortedAdvertisers.map((item) =>
            createData(
                item.companyName,
                item.companyWebsite,
                item.firstName,
                item.lastName,
                item.email,
                item.title,
                item.primaryPhone,
                item.mobilePhone,
                item.streetAddress,
                item.city,
                item.province,
                item.zipCode
            )
        );

        setTableRows(rows);
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };

    useEffect(() => {
        addDataToRows();
    }, [agencysAdvertisers]);

    const noAdvertisers = agencysAdvertisers?.length === 0;

    return (
        <>
            <ViewAdvertisersContainer>
                <Title>View Advertisers</Title>
                <StyledTableContainer>
                    <div>
                        <div
                            style={{
                                width: '100%',
                                maxWidth: '1500px',
                                display: 'table',
                                tableLayout: 'fixed',
                            }}
                        >
                            <TableContainer
                                style={{
                                    border: '1px solid black',
                                    borderRadius: '12px',
                                    backgroundColor: ' #fafbf7',
                                }}
                                component={Paper}
                            >
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Company Name</TableCell>
                                            <TableCell align="right">First Name</TableCell>
                                            <TableCell align="right">Last Name</TableCell>
                                            <TableCell align="right">Title</TableCell>
                                            <TableCell align="right">Company Website</TableCell>
                                            <TableCell align="right">Mobile Phone</TableCell>
                                            <TableCell align="right">Street Address </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableRows.map((row, idx) => (
                                            <TableRow
                                                key={idx}
                                                sx={{
                                                    '&:last-child td, &:last-child th': {
                                                        border: 0,
                                                    },
                                                }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {row.companyName}
                                                </TableCell>
                                                <TableCell align="right">{row.firstName}</TableCell>
                                                <TableCell align="right">{row.lastName}</TableCell>
                                                <TableCell align="right">{row.title}</TableCell>
                                                <TableCell align="right">
                                                    {row.companyWebsite}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.mobilePhone}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.streetAddress}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </StyledTableContainer>
                {noAdvertisers ? (
                    <div
                        style={{
                            textAlign: 'center',
                            backgroundColor: 'white',
                        }}
                    >
                        There are no saved advertisers for this agency.
                    </div>
                ) : null}
                <StyledNavButtons>
                    {/* {role.isAgencyManager ? ( */}
                    <StyledButton onClick={() => setModalIsOpen(true)}>
                        Add A New Advertiser
                    </StyledButton>
                    {/* ) : null} */}
                </StyledNavButtons>
            </ViewAdvertisersContainer>
            <AddAdvertiserModal
                newAdvertiser={newAdvertiser}
                setNewAdvertiser={setNewAdvertiser}
                createNewAdvertiser={createNewAdvertiser}
                handleClose={handleClose}
                modalIsOpen={modalIsOpen}
                postData={postData}
                resetFields={resetFields}
            />
        </>
    );
};

ViewAdvertisers.propTypes = {
    advertisers: propTypes.shape({
        advertiserList: propTypes.array,
        selectedAdvertiser: propTypes.shape({
            advertiserId: propTypes.number,
            stripeCustomerId: propTypes.string,
        }),
    }),
    agencyAdvertiserData: propTypes.array,
    profile: propTypes.shape({
        isAgency: propTypes.bool,
        isIndividual: propTypes.bool,
        isSiteAdmin: propTypes.bool,
    }),
    resetFields: propTypes.func,
    createNewAdvertiser: propTypes.func,
    newAdvertiser: propTypes.shape({}),
    setNewAdvertiser: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
        message: propTypes.array,
    }),
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    currentAdvertiser: propTypes.shape({
        isAgencyManager: propTypes.bool,
        isAgencyPrimary: propTypes.bool,
    }),
};

ViewAdvertisers.defaultProps = {
    advertisers: {},
    setAdvertisers: () => {},
    campaigns: { selectedCampaign: { dealName: '' } },
    modalIsOpen: false,
    setModalIsOpen: () => {},
    currentAdvertiser: {},
};
export default ViewAdvertisers;
